// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.demo {
  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);
  padding: 60px 0 50px 0;
}
.demo__container{
    width: 1200px;
    margin: 0 auto;
    max-width: 100%;
    height: 100%;
}
.demo__title {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 47px;
  margin-bottom: 35px;
}
.video-wrapp {
    position: relative;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (930/530 = 1.75) */
  }
  
  .video-wrapp iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`, "",{"version":3,"sources":["webpack://./src/components/DemoVideo/demoVideo.css"],"names":[],"mappings":"AAAA;EACE,iFAAiF;EACjF,sBAAsB;AACxB;AACA;IACI,aAAa;IACb,cAAc;IACd,eAAe;IACf,YAAY;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB,EAAE,uCAAuC;EAC9D;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;EACd","sourcesContent":[".demo {\n  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n  padding: 60px 0 50px 0;\n}\n.demo__container{\n    width: 1200px;\n    margin: 0 auto;\n    max-width: 100%;\n    height: 100%;\n}\n.demo__title {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 47px;\n  margin-bottom: 35px;\n}\n.video-wrapp {\n    position: relative;\n    width: 100%;\n    padding-top: 56.25%; /* 16:9 Aspect Ratio (930/530 = 1.75) */\n  }\n  \n  .video-wrapp iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
